require('./filesAndIconsManager.tpl.html');
require('./filesAndIconsManagerModel.js');
require('./filesAndIconsManagerActionRepository.js');
require('./filesAndIconsManagerRepository.js');

const locale = require('./filesAndIconsManager.i18n.json');
const Promise = require('bluebird');

/*@ngInject*/
const FilesAndIconsManagerController = function ($rootScope, $scope, $state, coreConstant, configurationMediator, configuredFileAction, modalUtil, filesAndIconsManagerModel, currentUserModel, authorizationConstants, configurationConstant, formatUtil, configurationActionsUtil, databaseDownloadSectionName, loadingBarHandler, attachmentUtil, preferenceModel) {

    let newCustomFileOrIconRowId = 0;

    $scope.i18n = locale.filesAndIconsManager;

    $scope.viewModel = {
        hasManagePermission: currentUserModel.hasAuthorization(authorizationConstants.MANAGE_CUSTOM_FILES_AND_ICONS),
        isLoading: true,
        filesAndIconsGroupings: [],
        customFilesAndIcons: [],
        controlsFrozen: false
    };

    $scope.actions = [];
    $scope.context = {
        identifier: 'filesAndIconsManager',
        actions: {},
        fallthrough: null,
        model: {
            contextType: coreConstant.CONTEXT_NONE
        }
    };
    $scope.context.actions[coreConstant.CONTEXT_NONE] = '';

    function init() {
        loadActions();
        loadConfiguredFiles();
    }

    function loadActions() {
        configurationMediator.loadFilesAndIconsManagerActions().then(function (actions) {
            const allActions = [];
            allActions.push({
                actions: actions.actions,
                contextType: $scope.context.model.contextType
            });
            processActions(allActions);
        });
    }

    function processActions(actions) {
        $scope.actions = actions;
        $scope.actionSubTexts = {};

        _.each($scope.actions, function (subAction) {
            _.each(subAction.actions, function (action) {
                if (action.name === configuredFileAction.SAVE) {
                    action.enabled = false;
                    if (filesAndIconsManagerModel.hasUnsavedChanges()) {
                        $scope.actionSubTexts[action.name] = {
                            class: 'unsavedChanges',
                            text: _.get($scope.i18n, 'unsavedChanges')
                        };

                        if (allRequiredFieldsFilled()) {
                            action.enabled = true;
                        }
                    }
                }

                if (action.name === configuredFileAction.DISCARD) {
                    action.enabled = filesAndIconsManagerModel.hasUnsavedChanges();
                }
            });
        });

        $scope.actionsTimeLastModified = new Date().getTime();
    }

    function allRequiredFieldsFilled() {
        let allFilled = true;
        _.each(filesAndIconsManagerModel.getModifiedFileOrIcons(), function (modifiedFileOrIcon) {
            if (_.isNil(modifiedFileOrIcon.name) || (_.isNil(modifiedFileOrIcon.fileName) && !modifiedFileOrIcon.required)) {
                allFilled = false;
                return false;
            }
        });
        return allFilled;
    }

    function loadConfiguredFiles() {
        $scope.viewModel.isLoading = true;

        configurationMediator.getConfiguredFiles().then(function (configuredFiles) {
            filesAndIconsManagerModel.setConfiguredFiles(configuredFiles);
            processConfiguredFiles(configuredFiles);
        }).finally(function () {
            $scope.viewModel.isLoading = false;
        });
    }

    function processConfiguredFiles(configuredFiles) {
        let processedConfiguredFiles = _.cloneDeep(configuredFiles);

        $scope.viewModel.filesAndIconsGroupings = [];
        $scope.viewModel.customFilesAndIcons = [];

        const filesAndIconsMap = {};

        _.each(processedConfiguredFiles, function (configuredFile) {
            if (_.isEmpty(configuredFile.grouping)) {
                configuredFile.rowId = newCustomFileOrIconRowId++;
                $scope.viewModel.customFilesAndIcons.push(configuredFile);
            } else if (configuredFile.required) {
                if (!_.has(filesAndIconsMap, configuredFile.grouping)) {
                    filesAndIconsMap[configuredFile.grouping] = [];
                }

                configuredFile.name = _.get($scope.i18n, `fileOrIconNames.${configuredFile.name}`) || configuredFile.name;

                filesAndIconsMap[configuredFile.grouping].push(configuredFile);
            }
        });

        _.forOwn(filesAndIconsMap, function (filesAndIcons, grouping) {
            filesAndIconsMap[grouping] = _.sortBy(filesAndIcons, 'name');
        });
        const groupings = _.sortBy(_.keys(filesAndIconsMap));
        _.each(groupings, function (grouping) {
            $scope.viewModel.filesAndIconsGroupings.push({
                grouping: _.get($scope.i18n, `groupingNames.${grouping}`) || grouping,
                filesAndIcons: filesAndIconsMap[grouping]
            });
        });

        $scope.viewModel.customFilesAndIcons = _.sortBy($scope.viewModel.customFilesAndIcons, 'id');
        $scope.addNewCustomFilesAndIconsRow();
    }

    $scope.handleAction = function (action, file) {
        if (action.enabled) {
            switch (action.name) {
                case configuredFileAction.SAVE:
                    loadingBarHandler.showNotificationLoadingBar(_.get($scope.i18n, 'saveFilesAndIcons.loadingBar'));
                    saveModifiedFileOrIcons(filesAndIconsManagerModel.getModifiedFileOrIcons()).then(function () {
                        if (_.isEmpty(filesAndIconsManagerModel.getModifiedFileOrIcons())) {
                            filesAndIconsManagerModel.setUnsavedChanges(false);
                        }
                        processActions($scope.actions);
                        loadingBarHandler.concludeNotificationLoadingBar(_.get($scope.i18n, 'saveFilesAndIcons.savingSystemPreferencesSuccessLoadingBar'));
                    });
                    break;

                case configuredFileAction.DISCARD:
                    modalUtil.showConfirmationModal(null, null, null, 'filesAndIconsManager.discardConfirmation', null, true, function () {
                        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get($scope.i18n, 'discardConfirmation.success'));
                        filesAndIconsManagerModel.setUnsavedChanges(false);
                        filesAndIconsManagerModel.resetModifiedFileOrIcons();
                        $state.reload();
                    });
                    break;

                case configuredFileAction.BACKUP:
                    configurationActionsUtil.backup(databaseDownloadSectionName.FILES_AND_ICONS, $scope.i18n.backup.name,
                        $scope.i18n.backup.loadingBar, $scope.i18n.backup.successMessage);
                    break;

                default:
                    modalUtil.showActionNotImplementedModal(action.name);
                    break;
            }
        }
    };

    $scope.showControls = function (fileOrIcon) {
        if ($scope.viewModel.hasManagePermission) {
            fileOrIcon.controlsVisible = true;
        }
        fileOrIcon.showDescription = !_.isEmpty(fileOrIcon.description);
    };

    $scope.hideControls = function (fileOrIcon) {
        if (!fileOrIcon.controlsFrozen) {
            fileOrIcon.controlsVisible = false;
        }
        fileOrIcon.showDescription = false;
    };

    $scope.getClassName = function (item) {
        return formatUtil.formatAsSelector(item);
    };

    $scope.onCustomFileOrIconNameChange = function (customFileOrIcon) {
        addModifiedFileOrIcon(customFileOrIcon);

        checkForAddingNewCustomFileOrIconRow(customFileOrIcon);
    };

    $scope.onCustomFileOrIconDescriptionChange = function (customFileOrIcon) {
        addModifiedFileOrIcon(customFileOrIcon);

        checkForAddingNewCustomFileOrIconRow(customFileOrIcon);
    };

    $scope.onCustomFileOrIconIsCarrierOnlyChange = function (customFileOrIcon) {
        addModifiedFileOrIcon(customFileOrIcon);

        checkForAddingNewCustomFileOrIconRow(customFileOrIcon);
    };

    $scope.onFileOrIconDataFileSelected = function (file, fileOrIcon) {
        let acceptedTypes = preferenceModel.get('system.allowedFilesAndIconsTypes').split('::');
        const allowFile = attachmentUtil.validateAttachmentType(file, _.get($scope.i18n, 'unacceptableType'), acceptedTypes, null);
        if(allowFile){
            fileOrIcon.fileName = file.name;
            fileOrIcon.file = file;

            addModifiedFileOrIcon(fileOrIcon);

            checkForAddingNewCustomFileOrIconRow(fileOrIcon);
        }
    };

    $scope.onFileOrIconDataFileDeleted = function (fileOrIcon) {
        fileOrIcon.fileName = null;
        fileOrIcon.file = null;

        addModifiedFileOrIcon(fileOrIcon);
    };

    $scope.onCustomFileOrIconRowDeleted = function (customFileOrIcon) {
        _.remove($scope.viewModel.customFilesAndIcons, function (item) {
            return item.rowId === customFileOrIcon.rowId;
        });

        if (!_.isNil(customFileOrIcon.id)) {
            customFileOrIcon.isDelete = true;
            addModifiedFileOrIcon(customFileOrIcon);
        } else {
            filesAndIconsManagerModel.removeFromModifiedFileOrIcons(customFileOrIcon);
        }

        filesAndIconsManagerModel.setUnsavedChanges(true);
        $scope.$broadcast(configurationConstant.event.FILES_AND_ICONS_MANAGER_MODEL_UPDATED);
    };

    $scope.isModified = function (fileOrIcon) {
        let index = findElementIndexByIdOrRowId(filesAndIconsManagerModel.getModifiedFileOrIcons(), fileOrIcon.id, fileOrIcon.rowId);
        return !_.isNil(index) && index >= 0;
    };

    function addModifiedFileOrIcon(modifiedFileOrIcon) {
        let existingModifiedFileOrIconIndex = findElementIndexByIdOrRowId(filesAndIconsManagerModel.getModifiedFileOrIcons(), modifiedFileOrIcon.id, modifiedFileOrIcon.rowId);

        if (_.isNil(existingModifiedFileOrIconIndex) || existingModifiedFileOrIconIndex === -1) {
            filesAndIconsManagerModel.addToModifiedFileOrIcons(modifiedFileOrIcon);
        }

        filesAndIconsManagerModel.setUnsavedChanges(true);
        $scope.$broadcast(configurationConstant.event.FILES_AND_ICONS_MANAGER_MODEL_UPDATED);
    }

    function findElementIndexByIdOrRowId(fileOrIconsArray, fileOrIconId, rowId) {
        return _.findIndex(fileOrIconsArray, function (item) {
            if (!_.isNil(item.id) && !_.isNil(fileOrIconId)) {
                return item.id === fileOrIconId;
            } else if (!_.isNil(item.rowId) && !_.isNil(rowId)) {
                return item.rowId === rowId;
            }
        });
    }

    function saveModifiedFileOrIcons(modifiedFileOrIcons) {
        let saveFileOrIconPromises = [];
        _.each(modifiedFileOrIcons, function (modifiedFileOrIcon) {
            let saveFileOrIconPromise;
            if (modifiedFileOrIcon.isDelete) {
                saveFileOrIconPromise = function () {
                    return configurationMediator.deleteConfiguredFile(modifiedFileOrIcon.id).then(function () {
                        filesAndIconsManagerModel.removeFromModifiedFileOrIcons(modifiedFileOrIcon);
                    });
                };
            } else {
                saveFileOrIconPromise = function () {
                    return configurationMediator.saveConfiguredFile(modifiedFileOrIcon).then(function (responseEntity) {
                        filesAndIconsManagerModel.removeFromModifiedFileOrIcons(modifiedFileOrIcon);
                        updateCustomFileOrIconWithResponseEntityData(modifiedFileOrIcon.rowId, responseEntity);
                    });
                };
            }

            saveFileOrIconPromises.push(saveFileOrIconPromise);
        });

        return Promise.mapSeries(saveFileOrIconPromises, function (saveFileOrIconPromise) {
            return saveFileOrIconPromise();
        });
    }

    function updateCustomFileOrIconWithResponseEntityData(rowId, savedCustomFileOrIcon) {
        let index = findElementIndexByIdOrRowId($scope.viewModel.customFilesAndIcons, savedCustomFileOrIcon.id, rowId);
        if (!_.isNil(index) && index >= 0) {
            $scope.viewModel.customFilesAndIcons[index] = savedCustomFileOrIcon;
        }
    }

    function checkForAddingNewCustomFileOrIconRow(customFileOrIcon) {
        if (customFileOrIcon.newRow) {
            customFileOrIcon.newRow = false;
            $scope.addNewCustomFilesAndIconsRow();
        }
    }

    $scope.addNewCustomFilesAndIconsRow = function () {
        $scope.viewModel.customFilesAndIcons.push({
            newRow: true,
            rowId: newCustomFileOrIconRowId++
        });
    };

    $scope.freezeControls = function (fileOrIcon) {
        fileOrIcon.controlsFrozen = true;
    };

    $scope.unfreezeControls = function (fileOrIcon) {
        fileOrIcon.controlsFrozen = false;
        $scope.hideControls(fileOrIcon);
    };

    $scope.$on(configurationConstant.event.FILES_AND_ICONS_MANAGER_MODEL_UPDATED, function () {
        processActions($scope.actions);
    });

    $scope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {
        const isCurrentStateFilesAndIconsPreferencesManager = _.startsWith(fromState.name, 'configuration.filesAndIconsManager'),
            isTargetSameAsCurrent = toState.name === fromState.name;

        if (toState.name === 'login') {
            return;
        }

        if (filesAndIconsManagerModel.hasUnsavedChanges() && isCurrentStateFilesAndIconsPreferencesManager && !isTargetSameAsCurrent && filesAndIconsManagerModel.getModifiedFileOrIcons()) {
            event.preventDefault();

            if (allRequiredFieldsFilled()) {
                loadingBarHandler.showNotificationLoadingBar(_.get($scope.i18n, 'saveFilesAndIcons.loadingBar'));
                saveModifiedFileOrIcons(filesAndIconsManagerModel.getModifiedFileOrIcons()).then(function () {
                    if (_.isEmpty(filesAndIconsManagerModel.getModifiedFileOrIcons())) {
                        filesAndIconsManagerModel.setUnsavedChanges(false);
                        filesAndIconsManagerModel.resetModifiedFileOrIcons();
                        $state.go(toState, toParams);
                    }

                    loadingBarHandler.concludeNotificationLoadingBar(_.get($scope.i18n, 'saveFilesAndIcons.savingSystemPreferencesSuccessLoadingBar'));
                });
            } else {
                modalUtil.showConfirmationModal(null, null, null, 'filesAndIconsManager.autoSaveRequiredFields', null, true, function () {
                    $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get($scope.i18n, 'discardConfirmation.success'));
                    filesAndIconsManagerModel.setUnsavedChanges(false);
                    filesAndIconsManagerModel.resetModifiedFileOrIcons();
                    $state.go(toState, toParams);
                });
            }
        } else {
            if (isCurrentStateFilesAndIconsPreferencesManager && isTargetSameAsCurrent && filesAndIconsManagerModel.hasUnsavedChanges()) {
                filesAndIconsManagerModel.setUnsavedChanges(false);
                $state.reload();
            }
        }
    });

    init();
};

angular.module('ums.configuration')
    .controller('filesAndIconsManagerController', FilesAndIconsManagerController);
